import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    listClientes, listEmbarques, listEmbarqueSeriales, listEmbarqueUltimoNumeros, listPProduccions, listUbicacions,
    listRecibaSeriales, listLocacions, listNotificaciones, listPlaneacions, listPlaneacionUltimoNumeros, listPProduccionUltimoNumeros,
    listProductos, listRecibas, listRecibaUltimoNumeros, listRecuperacions, listTickets, listTicketStatuses,
    listTicketUltimoNumeros, listUsuarios
} from '../../graphql/queries';
import * as IoIcons from 'react-icons/io';
import Moment, { updateLocale } from 'moment';
import QrReader from "react-qr-reader";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { CSVLink, CSVDownload } from "react-csv";
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Producción' }


function Respaldo() {
    //Declaración de variables            
    const [clientes, setClientes] = useState([]);
    const [embarques, setEmbarques] = useState([]);
    const [embarquesSeriales, setEmbarquesSeriales] = useState([]);

    const [embarqueUltimoNumero, setEmbarqueUltimoNumero] = useState([]);
    const [locacion, setLocacion] = useState([]);
    const [notificaciones, setNotificaciones] = useState([]);
    const [planeacion, setPlaneacion] = useState([]);
    const [planeacionUltimoNumero, setPlaneacionUltimoNumero] = useState([]);
    const [pProduccionUltimoNumero, setPProduccionUltimoNumero] = useState([]);
    const [producto, setProducto] = useState([]);
    const [reciba, setReciba] = useState([]);
    const [recibaSeriales, setRecibaSeriales] = useState([]);
    const [recibaUltimoNumero, setRecibaUltimoNumero] = useState([]);
    const [recuperacion, setRecuperacion] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [ticketStatus, setTicketStatus] = useState([]);
    const [ticketUltimoNumero, setTicketUltimoNumero] = useState([]);
    const [ubicacion, setUbicacion] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const [pProduccionPEyP, setPProduccionPEyP] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const prespaldo = userName === "GELA" ? true : false;
    const [cargando, setCargando] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const onDismiss = () => setAVisible(false);
    Moment.locale('en');
    var now = new Date();
    const fecha = Moment(now).format("DD-MM-YYYY")

    //Método useEffect
    useEffect(() => {
        cargarDatos();
    }, []);
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listClientes, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listClientes.items;
            nextToken = await apiOData.data.listClientes.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setClientes(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de los embarques
    async function fetchEmbarques() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listEmbarques, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listEmbarques.items;
            nextToken = await apiOData.data.listEmbarques.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setEmbarques(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de los embarquesSeriales
    async function fetchEmbarquesSeriales() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listEmbarqueSeriales, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listEmbarqueSeriales.items;
            nextToken = await apiOData.data.listEmbarqueSeriales.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setEmbarquesSeriales(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de EmbarqueUltimoNumero
    async function fetchEmbarqueUltimoNumero() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listEmbarqueUltimoNumeros, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listEmbarqueUltimoNumeros.items;
            nextToken = await apiOData.data.listEmbarqueUltimoNumeros.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setEmbarqueUltimoNumero(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de Locaciones
    async function fetchLocacion() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listLocacions, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listLocacions.items;
            nextToken = await apiOData.data.listLocacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setLocacion(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de Notificaciones
    async function fetchNotificaciones() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listNotificaciones, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listNotificaciones.items;
            nextToken = await apiOData.data.listNotificaciones.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setNotificaciones(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de  Planeaciones
    async function fetchPlaneaciones() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listPlaneacions, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listPlaneacions.items;
            nextToken = await apiOData.data.listPlaneacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setPlaneacion(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de  PlaneacionUltimoNumero
    async function fetchPlaneacionUltimoNumero() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listPlaneacionUltimoNumeros, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listPlaneacionUltimoNumeros.items;
            nextToken = await apiOData.data.listPlaneacionUltimoNumeros.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setPlaneacionUltimoNumero(apiData);
        //setCargando(false);
    }
    //Obtiene los datos guardados de los planes de producción
    async function fetchPlanProduccion() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listPProduccions, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listPProduccions.items;
            nextToken = await apiOData.data.listPProduccions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setPProduccionPEyP(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de ProduccionUltimoNumero
    async function fetchProduccionUltimoNumero() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listPProduccionUltimoNumeros.items;
            nextToken = await apiOData.data.listPProduccionUltimoNumeros.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setPProduccionUltimoNumero(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de Productos
    async function fetchProductos() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listProductos, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listProductos.items;
            nextToken = await apiOData.data.listProductos.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setProducto(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de Reciba
    async function fetchRecibas() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listRecibas, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listRecibas.items;
            nextToken = await apiOData.data.listRecibas.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setReciba(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  RecibaSeriales
    async function fetchRecibaSeriales() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listRecibaSeriales, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listRecibaSeriales.items;
            nextToken = await apiOData.data.listRecibaSeriales.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setRecibaSeriales(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  RecibaUltimoNumero
    async function fetchRecibaUltimoNumero() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listRecibaUltimoNumeros, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listRecibaUltimoNumeros.items;
            nextToken = await apiOData.data.listRecibaUltimoNumeros.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setRecibaUltimoNumero(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  Recuperacion
    async function fetchRecuperacion() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listRecuperacions, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listRecuperacions.items;
            nextToken = await apiOData.data.listRecuperacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setRecuperacion(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  Tickets
    async function fetchTickets() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listTickets, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listTickets.items;
            nextToken = await apiOData.data.listTickets.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setTickets(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  TicketStatus
    async function fetchTicketStatus() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listTicketStatuses, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listTicketStatuses.items;
            nextToken = await apiOData.data.listTicketStatuses.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setTicketStatus(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  TicketUltimoNumero
    async function fetchTicketUltimoNumero() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listTicketUltimoNumeros, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listTicketUltimoNumeros.items;
            nextToken = await apiOData.data.listTicketUltimoNumeros.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setTicketUltimoNumero(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  Ubicacion
    async function fetchUbicacion() {
        //setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listUbicacions, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listUbicacions.items;
            nextToken = await apiOData.data.listUbicacions.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setUbicacion(apiData);
        //setCargando(false);

    }
    //Obtiene los datos guardados de  Usuarios
    async function fetchUsuarios() {
        // setCargando(true);
        var nextToken = null;
        var apiData = [];
        do {
            const apiOData = await API.graphql({ query: listUsuarios, variables: { limit: 100000000, nextToken } });
            const odatos = await apiOData.data.listUsuarios.items;
            nextToken = await apiOData.data.listUsuarios.nextToken;
            apiData = await [...apiData, ...odatos];
        } while (nextToken != null);
        setUsuarios(apiData);
        //setCargando(false);

    }
    //Se obtienen los datos de todas las tablas
    async function cargarDatos() {
        fetchClientes();
        fetchEmbarques();
        fetchEmbarquesSeriales();
        fetchEmbarqueUltimoNumero();
        fetchLocacion();
        fetchNotificaciones();
        fetchPlaneaciones();
        fetchPlaneacionUltimoNumero();
        fetchPlanProduccion();
        fetchProduccionUltimoNumero();
        fetchProductos();
        fetchRecibas();
        fetchRecibaSeriales();
        fetchRecibaUltimoNumero();
        fetchRecuperacion();
        fetchTickets();
        fetchTicketStatus();
        fetchTicketUltimoNumero();
        fetchUbicacion();
        fetchUsuarios();
    }
    return (
        <>
            {prespaldo == true && (
                <>
                    <Fragment>

                        <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px" >
                                <button className="cbutton btn-dark floatright  ml-2 " title="Recargar página" onClick={() => { cargarDatos(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                            </div>
                        </Row>
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                                    {mensajeAlert}
                                </Alert>
                            </div>
                            {cargando === true && (
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            )}
                        </Row>
                        <h5 className="margintop20px floatleft ml-3">Tablas</h5>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                            <Table className=" mb-2  ">
                                <Thead class="thead-secondary">
                                    <Tr>
                                        <Th >Número</Th>
                                        <Th >Tabla</Th>
                                        <Th >Acción</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    <Tr >
                                        <Td>1</Td>
                                        <Td>Clientes</Td>
                                        <Td>
                                            {!clientes.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {clientes.length > 0 && (
                                                <CSVLink data={clientes} filename={"Cliente " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active" >
                                        <Td>2</Td>
                                        <Td>Embarques</Td>
                                        <Td>
                                            {!embarques.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {embarques.length > 0 && (
                                                <CSVLink data={embarques} filename={"Embarque " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>3</Td>
                                        <Td>Embarques seriales</Td>
                                        <Td>
                                            {!embarquesSeriales.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {embarquesSeriales.length > 0 && (
                                                <CSVLink data={embarquesSeriales} filename={"EmbarqueSeriales " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active">
                                        <Td>4</Td>
                                        <Td>Embarques último número</Td>
                                        <Td>
                                            {!embarqueUltimoNumero.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {embarqueUltimoNumero.length > 0 && (
                                                <CSVLink data={embarqueUltimoNumero} filename={"EmbarqueUltimoNumero " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>5</Td>
                                        <Td>Locaciones</Td>
                                        <Td>
                                            {!locacion.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {locacion.length > 0 && (
                                                <CSVLink data={locacion} filename={"Locacion " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    {/*<Tr className="table-active">
                                        <Td>6</Td>
                                        <Td>Notificaciones</Td>
                                        <Td>
                                            {!notificaciones.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {notificaciones.length > 0 && (
                                                <CSVLink data={notificaciones} filename={"Notificaciones " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>*/}
                                    <Tr className="table-active" >
                                        <Td>6</Td>
                                        <Td>Planeaciones</Td>
                                        <Td>
                                            {!planeacion.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {planeacion.length > 0 && (
                                                <CSVLink data={planeacion} filename={"Planeacion " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>7</Td>
                                        <Td>Planeaciones último número</Td>
                                        <Td>
                                            {!planeacionUltimoNumero.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {planeacionUltimoNumero.length > 0 && (
                                                <CSVLink data={planeacionUltimoNumero} filename={"PlaneacionUltimoNumero " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active" >
                                        <Td>8</Td>
                                        <Td>Planes de producción</Td>
                                        <Td>
                                            {!pProduccionPEyP.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {pProduccionPEyP.length > 0 && (
                                                <CSVLink data={pProduccionPEyP} filename={"PProduccion " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>9</Td>
                                        <Td>Planes de producción último número</Td>
                                        <Td>
                                            {!pProduccionUltimoNumero.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {pProduccionUltimoNumero.length > 0 && (
                                                <CSVLink data={pProduccionUltimoNumero} filename={"PProduccionUltimoNumero " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active" >
                                        <Td>10</Td>
                                        <Td>Productos</Td>
                                        <Td>
                                            {!producto.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {producto.length > 0 && (
                                                <CSVLink data={producto} filename={"Producto " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>11</Td>
                                        <Td>Reciba</Td>
                                        <Td>
                                            {!reciba.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {reciba.length > 0 && (
                                                <CSVLink data={reciba} filename={"Reciba " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active">
                                        <Td>12</Td>
                                        <Td>Reciba Seriales</Td>
                                        <Td>
                                            {!recibaSeriales.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {recibaSeriales.length > 0 && (
                                                <CSVLink data={recibaSeriales} filename={"RecibaSeriales " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>13</Td>
                                        <Td>Reciba Seriales último número</Td>
                                        <Td>
                                            {!recibaUltimoNumero.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {recibaUltimoNumero.length > 0 && (
                                                <CSVLink data={recibaUltimoNumero} filename={"RecibaUltimoNumero " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active">
                                        <Td>14</Td>
                                        <Td>Recuperación</Td>
                                        <Td>
                                            {!recuperacion.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {recuperacion.length > 0 && (
                                                <CSVLink data={recuperacion} filename={"Recuperacion " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>15</Td>
                                        <Td>Tickets</Td>
                                        <Td>
                                            {!tickets.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {tickets.length > 0 && (
                                                <CSVLink data={tickets} filename={"Tickets " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active">
                                        <Td>16</Td>
                                        <Td>Tickets historial</Td>
                                        <Td>
                                            {!ticketStatus.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {ticketStatus.length > 0 && (
                                                <CSVLink data={ticketStatus} filename={"TicketStatus " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>17</Td>
                                        <Td>Tickets último número</Td>
                                        <Td>
                                            {!ticketUltimoNumero.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {ticketUltimoNumero.length > 0 && (
                                                <CSVLink data={ticketUltimoNumero} filename={"TicketUltimoNumero " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr className="table-active">
                                        <Td>18</Td>
                                        <Td>Ubicación del material</Td>
                                        <Td>
                                            {!ubicacion.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {ubicacion.length > 0 && (
                                                <CSVLink data={ubicacion} filename={"Ubicacion " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                    <Tr >
                                        <Td>19</Td>
                                        <Td>Usuarios</Td>
                                        <Td>
                                            {!usuarios.length && (
                                                <img width="150px" src="assets/img/preloader.gif" />
                                            )}
                                            {usuarios.length > 0 && (
                                                <CSVLink data={usuarios} filename={"Usuarios " + fecha + ".csv"}>Descargar</CSVLink>
                                            )}
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </div>

                    </Fragment>

                </>
            )}
        </>
    )
};



export default Respaldo;
